module.exports = ['AT&T', 'Vodafone', 'Telefónica', 'Orange', 'América Móvil', 'MTN', 'Bharti Airtel', 'Axiata', 'Etisalat', 'Ooredoo'];
